(function () {
  'use strict';

  var STORAGE_KEY = 'decorExpressBenjaminMooreColour';
  var MAX_RESULTS = 80;
  var coloursPromise = null;
  var configCache = null;

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&reg;/g, '')
      .replace(/[’‘]/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanText(value) {
    return String(value || '').replace(/&reg;/g, '').trim();
  }

  function normaliseHex(value) {
    var hex = String(value || '').replace('#', '').trim();
    return /^[0-9a-fA-F]{6}$/.test(hex) ? '#' + hex.toUpperCase() : '';
  }

  function readConfig() {
    if (configCache) return configCache;

    var node = document.querySelector('[data-bm-local-config]');
    if (!node) throw new Error('Benjamin Moore local colour configuration is missing.');

    try {
      configCache = JSON.parse(node.textContent || '{}');
    } catch (error) {
      throw new Error('Benjamin Moore local colour configuration is invalid.');
    }

    if (!Array.isArray(configCache.shards) || !configCache.shards.length) {
      throw new Error('Benjamin Moore local colour files are missing.');
    }

    return configCache;
  }

  function loadShard(url) {
    return fetch(url, { credentials: 'same-origin', cache: 'force-cache' }).then(function (response) {
      if (!response.ok) throw new Error('Could not load local Benjamin Moore colour file.');
      return response.json();
    });
  }

  function mapLocalRow(row, config) {
    if (!Array.isArray(row) || row.length < 5) return null;

    var name = cleanText(row[0]);
    var number = cleanText(row[1]);
    if (!name || !number) return null;

    return {
      name: name,
      number: number,
      hex: normaliseHex(row[2]),
      collection: config.collections && config.collections[row[3]] ? config.collections[row[3]] : '',
      family: config.families && config.families[row[4]] ? config.families[row[4]] : ''
    };
  }

  function loadAllColours() {
    if (coloursPromise) return coloursPromise;

    coloursPromise = Promise.resolve().then(function () {
      var config = readConfig();
      return Promise.all(config.shards.map(loadShard)).then(function (shards) {
        var colours = [];
        shards.forEach(function (rows) {
          if (!Array.isArray(rows)) return;
          rows.forEach(function (row) {
            var colour = mapLocalRow(row, config);
            if (colour) colours.push(colour);
          });
        });

        if (config.count && colours.length !== Number(config.count)) {
          throw new Error('Benjamin Moore local colour database is incomplete.');
        }

        return colours;
      });
    });

    return coloursPromise;
  }

  function readStoredColour() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.name || !parsed.number) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function storeColour(colour) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(colour));
    } catch (error) {
    }
  }

  function colourFromQuery() {
    var params = new URLSearchParams(window.location.search);
    var name = params.get('bm_colour');
    var number = params.get('bm_code');
    if (!name || !number) return null;

    return {
      name: name,
      number: number,
      hex: normaliseHex(params.get('bm_hex')),
      collection: cleanText(params.get('bm_collection')),
      family: cleanText(params.get('bm_family'))
    };
  }

  function buildSelect(className, label, values) {
    var wrap = document.createElement('label');
    wrap.className = 'bm-colour-filter';

    var title = document.createElement('span');
    title.textContent = label;

    var select = document.createElement('select');
    select.className = className;

    var all = document.createElement('option');
    all.value = '';
    all.textContent = 'All ' + label.toLowerCase();
    select.appendChild(all);

    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });

    wrap.appendChild(title);
    wrap.appendChild(select);
    return wrap;
  }

  function createSelectorMarkup(mode) {
    var wrapper = document.createElement('div');
    wrapper.className = 'bm-colour-selector bm-colour-selector--' + mode;
    wrapper.setAttribute('data-bm-selector-ui', '');

    var id = 'bm-colour-search-' + Math.random().toString(36).slice(2);
    wrapper.innerHTML =
      '<div class="bm-colour-search-row">' +
        '<label class="bm-colour-search-label" for="' + id + '">Search by colour name or code</label>' +
        '<div class="bm-colour-search-input-wrap">' +
          '<span class="bm-colour-search-icon" aria-hidden="true">&#128269;</span>' +
          '<input id="' + id + '" class="bm-colour-search" type="search" autocomplete="off" spellcheck="false" ' +
            'placeholder="e.g. White Dove or OC-17" data-bm-search>' +
        '</div>' +
      '</div>' +
      '<div class="bm-colour-filter-row" data-bm-filter-row hidden></div>' +
      '<div class="bm-colour-selected" data-bm-selected hidden>' +
        '<span class="bm-colour-selected-swatch" data-bm-selected-swatch aria-hidden="true"></span>' +
        '<span class="bm-colour-selected-copy">' +
          '<strong data-bm-selected-name></strong>' +
          '<span data-bm-selected-code></span>' +
        '</span>' +
        '<button type="button" class="bm-colour-change" data-bm-clear>Change</button>' +
      '</div>' +
      '<p class="bm-colour-status" data-bm-status aria-live="polite">Loading 3,870 local Benjamin Moore colours…</p>' +
      '<div class="bm-colour-results" data-bm-results hidden></div>';

    return wrapper;
  }

  function addCollectionFilters(ui) {
    var config = readConfig();
    var row = ui.querySelector('[data-bm-filter-row]');
    if (!row) return;

    row.appendChild(buildSelect('bm-colour-family-filter', 'Colour family', config.families || []));
    row.appendChild(buildSelect('bm-colour-collection-filter', 'Collection', config.collections || []));
    row.hidden = false;
  }

  function setStatus(ui, message, isError) {
    var status = ui.querySelector('[data-bm-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('bm-colour-status--error', !!isError);
    status.hidden = !message;
  }

  function metaLine(colour) {
    var bits = [colour.number];
    if (colour.family) bits.push(colour.family);
    if (colour.collection) bits.push(colour.collection);
    return bits.join(' · ');
  }

  function setSelectedUI(ui, colour) {
    var panel = ui.querySelector('[data-bm-selected]');
    var swatch = ui.querySelector('[data-bm-selected-swatch]');
    var name = ui.querySelector('[data-bm-selected-name]');
    var code = ui.querySelector('[data-bm-selected-code]');

    if (!panel) return;
    if (!colour) {
      panel.hidden = true;
      return;
    }

    panel.hidden = false;
    if (swatch) {
      swatch.style.backgroundColor = colour.hex || '#ffffff';
      swatch.classList.toggle('bm-colour-swatch--unknown', !colour.hex);
    }
    if (name) name.textContent = colour.name;
    if (code) code.textContent = metaLine(colour);
  }

  function getFilteredColours(ui, colours, query) {
    var q = normalise(query);
    var family = ui.querySelector('.bm-colour-family-filter');
    var collection = ui.querySelector('.bm-colour-collection-filter');
    var familyValue = family ? family.value : '';
    var collectionValue = collection ? collection.value : '';

    return colours.filter(function (colour) {
      if (familyValue && colour.family !== familyValue) return false;
      if (collectionValue && colour.collection !== collectionValue) return false;
      if (!q) return true;
      return normalise(colour.name).indexOf(q) !== -1 || normalise(colour.number).indexOf(q) !== -1;
    });
  }

  function renderResults(ui, colours, query, selectColour) {
    var results = ui.querySelector('[data-bm-results]');
    if (!results) return;

    results.innerHTML = '';
    var q = normalise(query);
    var family = ui.querySelector('.bm-colour-family-filter');
    var collection = ui.querySelector('.bm-colour-collection-filter');
    var hasFilter = !!((family && family.value) || (collection && collection.value));

    if (q.length < 2 && !hasFilter) {
      results.hidden = true;
      setStatus(ui, 'Type at least 2 characters, or use the filters to browse all 3,870 colours.', false);
      return;
    }

    var allMatched = getFilteredColours(ui, colours, q.length >= 2 ? query : '');
    var matched = allMatched.slice(0, MAX_RESULTS);

    if (!matched.length) {
      results.hidden = true;
      setStatus(ui, 'No Benjamin Moore colours match your search and filters. Try another name, code or filter.', false);
      return;
    }

    if (allMatched.length > MAX_RESULTS) {
      setStatus(ui, 'Showing the first ' + MAX_RESULTS + ' of ' + allMatched.length + ' matches — refine your search or filters.', false);
    } else {
      setStatus(ui, 'Showing ' + allMatched.length + (allMatched.length === 1 ? ' colour.' : ' colours.'), false);
    }

    matched.forEach(function (colour) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bm-colour-result';
      button.setAttribute('data-bm-colour-result', '');
      button.innerHTML =
        '<span class="bm-colour-result-swatch" aria-hidden="true"></span>' +
        '<span class="bm-colour-result-copy"><strong></strong><span></span></span>';

      var swatch = button.querySelector('.bm-colour-result-swatch');
      swatch.style.backgroundColor = colour.hex || '#ffffff';
      swatch.classList.toggle('bm-colour-swatch--unknown', !colour.hex);
      button.querySelector('strong').textContent = colour.name;
      button.querySelector('.bm-colour-result-copy span').textContent = metaLine(colour);
      button.addEventListener('click', function () { selectColour(colour); });
      results.appendChild(button);
    });

    results.hidden = false;
  }

  function canonicalColour(colours, selected) {
    if (!selected) return null;
    return colours.find(function (colour) {
      return normalise(colour.number) === normalise(selected.number);
    }) || null;
  }

  function updateProductLinks(colour) {
    if (!colour) return;

    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var raw = link.getAttribute('href');
      if (!raw || raw.indexOf('javascript:') === 0 || raw.charAt(0) === '#') return;

      try {
        var url = new URL(raw, window.location.origin);
        if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') === -1) return;

        url.searchParams.set('bm_colour', colour.name);
        url.searchParams.set('bm_code', colour.number);
        if (colour.hex) url.searchParams.set('bm_hex', colour.hex.replace('#', ''));
        if (colour.collection) url.searchParams.set('bm_collection', colour.collection);
        if (colour.family) url.searchParams.set('bm_family', colour.family);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (error) {
      }
    });
  }

  function positionCollectionFinder() {
    var finder = document.querySelector('.bm-collection-finder');
    var collectionHeader = document.querySelector('.collection .card > .card__header');
    if (finder && collectionHeader && finder.parentNode !== collectionHeader) collectionHeader.appendChild(finder);
  }

  function disableCollectionShortcuts() {
    document.querySelectorAll('.product-list--collection [data-secondary-action="open-quick-view"]').forEach(function (button) {
      button.hidden = true;
      button.setAttribute('aria-hidden', 'true');
      button.setAttribute('tabindex', '-1');
    });

    document.querySelectorAll('.product-list--collection form button[type="submit"]').forEach(function (button) {
      button.hidden = true;
      button.setAttribute('aria-hidden', 'true');
      button.setAttribute('tabindex', '-1');
    });
  }

  function watchCollectionShortcuts() {
    disableCollectionShortcuts();
    if (!window.MutationObserver || document.documentElement.hasAttribute('data-bm-shortcut-watch')) return;
    document.documentElement.setAttribute('data-bm-shortcut-watch', '');

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        disableCollectionShortcuts();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initCollectionSelector(loader) {
    if (loader.hasAttribute('data-bm-ready')) return;
    loader.setAttribute('data-bm-ready', '');
    positionCollectionFinder();
    watchCollectionShortcuts();

    var ui = createSelectorMarkup('collection');
    loader.appendChild(ui);
    addCollectionFilters(ui);

    var search = ui.querySelector('[data-bm-search]');
    var results = ui.querySelector('[data-bm-results]');
    var family = ui.querySelector('.bm-colour-family-filter');
    var collection = ui.querySelector('.bm-colour-collection-filter');
    var allColours = [];
    var selected = readStoredColour();

    function selectColour(colour) {
      selected = colour;
      storeColour(colour);
      setSelectedUI(ui, colour);
      if (search) search.value = colour.name + ' ' + colour.number;
      if (results) results.hidden = true;
      setStatus(ui, 'Colour selected. Next, choose the paint finish that suits your room or surface.', false);
      updateProductLinks(colour);
      loader.dispatchEvent(new CustomEvent('bm:colour-selected', { bubbles: true, detail: colour }));
    }

    function refresh() {
      renderResults(ui, allColours, search ? search.value : '', selectColour);
    }

    ui.querySelector('[data-bm-clear]').addEventListener('click', function () {
      selected = null;
      setSelectedUI(ui, null);
      if (search) { search.value = ''; search.focus(); }
      if (family) family.value = '';
      if (collection) collection.value = '';
      if (results) results.hidden = true;
      setStatus(ui, 'Type at least 2 characters, or use the filters to browse all 3,870 colours.', false);
    });

    loadAllColours().then(function (colours) {
      allColours = colours;
      var canonical = canonicalColour(allColours, selected);
      if (canonical) selectColour(canonical);
      else setStatus(ui, '3,870 colours ready. Search by name/code or browse by family and collection.', false);
    }).catch(function (error) {
      console.error('Benjamin Moore local colour database error:', error);
      setStatus(ui, 'The local Benjamin Moore colour library could not be loaded. Please refresh the page.', true);
    });

    search.addEventListener('input', refresh);
    if (family) family.addEventListener('change', refresh);
    if (collection) collection.addEventListener('change', refresh);
  }

  function findProductForm(legacyPalette, legacyColour) {
    return (legacyColour && legacyColour.closest('form[action*="/cart/add"]')) ||
      (legacyPalette && legacyPalette.closest('form[action*="/cart/add"]')) ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.product-form form');
  }

  function createHidden(form, attribute, name) {
    var field = form.querySelector('input[' + attribute + ']');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.setAttribute(attribute, '');
      form.appendChild(field);
    }

    field.type = 'hidden';
    field.name = name;
    field.disabled = false;
    return field;
  }

  function notifyField(field) {
    if (!field) return;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initProductSelector(loader) {
    if (document.querySelector('.bm-product-colour-field')) return;

    var legacyPalette = document.querySelector('.product-form__meta-color-pallete-code');
    var legacyColour = document.querySelector('.product-form__meta-color-pallete');
    if (!legacyPalette || !legacyColour) return;

    legacyPalette.classList.remove('product-form__meta-color-pallete-code');
    legacyColour.classList.remove('product-form__meta-color-pallete');

    var form = findProductForm(legacyPalette, legacyColour);
    if (!form) return;

    var paletteBlock = legacyPalette.closest('.product-form__info-item');
    var colourBlock = legacyColour.closest('.product-form__info-item');
    var anchor = paletteBlock || colourBlock;

    legacyPalette.disabled = true;
    legacyColour.disabled = true;
    if (paletteBlock) paletteBlock.hidden = true;
    if (colourBlock) colourBlock.hidden = true;

    var hiddenColour = createHidden(form, 'data-bm-hidden-colour', 'properties[Colour]');
    var hiddenCode = createHidden(form, 'data-bm-hidden-code', 'properties[_Benjamin Moore Code]');
    var hiddenHex = createHidden(form, 'data-bm-hidden-hex', 'properties[_Benjamin Moore HEX]');
    var hiddenCollection = createHidden(form, 'data-bm-hidden-collection', 'properties[_Benjamin Moore Collection]');
    var hiddenFamily = createHidden(form, 'data-bm-hidden-family', 'properties[_Benjamin Moore Family]');

    var item = document.createElement('div');
    item.className = 'product-form__info-item meta-info-block bm-product-colour-field';

    var title = document.createElement('label');
    title.className = 'product-form__info-title text--strong';
    title.textContent = 'Colour:';

    var content = document.createElement('div');
    content.className = 'product-form__info-content';
    var ui = createSelectorMarkup('product');
    content.appendChild(ui);
    item.appendChild(title);
    item.appendChild(content);

    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(item, anchor);
    else form.insertBefore(item, form.firstChild);

    var accelerated = form.querySelector('.shopify-payment-button');
    if (accelerated) accelerated.hidden = true;

    var search = ui.querySelector('[data-bm-search]');
    var results = ui.querySelector('[data-bm-results]');
    var allColours = [];
    var selected = colourFromQuery() || readStoredColour();

    function selectColour(colour) {
      selected = colour;
      hiddenColour.value = colour.name + ' (' + colour.number + ')';
      hiddenCode.value = colour.number;
      hiddenHex.value = colour.hex || '';
      hiddenCollection.value = colour.collection || '';
      hiddenFamily.value = colour.family || '';
      [hiddenColour, hiddenCode, hiddenHex, hiddenCollection, hiddenFamily].forEach(notifyField);
      storeColour(colour);
      setSelectedUI(ui, colour);
      if (search) search.value = colour.name + ' ' + colour.number;
      if (results) results.hidden = true;
      setStatus(ui, 'Selected colour will be included with your mixed-to-order paint.', false);
      item.classList.remove('bm-product-colour-field--error');
    }

    function clearColour() {
      selected = null;
      hiddenColour.value = '';
      hiddenCode.value = '';
      hiddenHex.value = '';
      hiddenCollection.value = '';
      hiddenFamily.value = '';
      [hiddenColour, hiddenCode, hiddenHex, hiddenCollection, hiddenFamily].forEach(notifyField);
      setSelectedUI(ui, null);
      if (search) { search.value = ''; search.focus(); }
      if (results) results.hidden = true;
      setStatus(ui, 'Type at least 2 characters to search by colour name or code.', false);
    }

    ui.querySelector('[data-bm-clear]').addEventListener('click', clearColour);

    loadAllColours().then(function (colours) {
      allColours = colours;
      var canonical = canonicalColour(allColours, selected);
      if (canonical) selectColour(canonical);
      else clearColour();
    }).catch(function (error) {
      console.error('Benjamin Moore local colour database error:', error);
      clearColour();
      setStatus(ui, 'The local Benjamin Moore colour library could not be loaded. Please refresh the page.', true);
    });

    search.addEventListener('input', function () {
      renderResults(ui, allColours, search.value, selectColour);
    });

    function validateColourSelection(event) {
      if (hiddenColour.value) return true;

      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      item.classList.add('bm-product-colour-field--error');
      setStatus(ui, 'Please select a Benjamin Moore colour before adding this paint to your basket.', true);

      if (search) {
        search.focus();
        search.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return false;
    }

    form.addEventListener('submit', function (event) {
      validateColourSelection(event);
    }, true);

    form.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('.product-form__add-button[type="submit"]');
      if (!button || !form.contains(button)) return;

      validateColourSelection(event);
    }, true);

    form.addEventListener('formdata', function (event) {
      if (!hiddenColour.value) return;

      event.formData.set('properties[Colour]', hiddenColour.value);
      event.formData.set('properties[_Benjamin Moore Code]', hiddenCode.value);
      event.formData.set('properties[_Benjamin Moore HEX]', hiddenHex.value);
      event.formData.set('properties[_Benjamin Moore Collection]', hiddenCollection.value);
      event.formData.set('properties[_Benjamin Moore Family]', hiddenFamily.value);
    });
  }

  function boot() {
    document.querySelectorAll('[data-bm-collection-loader]').forEach(initCollectionSelector);
    document.querySelectorAll('[data-bm-product-loader]').forEach(initProductSelector);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('variant:changed', function () {
    window.setTimeout(boot, 60);
  });
})();
